import React from "react";
import { Modal } from "antd";
import Button from "../Button";
import "./ReusableModal.scss";

const ReusableModal = ({
  isOpen,
  title,
  onClose,
  children,
  onOk,
  cancelText,
  onOkText,
  style,
  modalstyles,
  showCloseIcon
}) => {
  const handleOk = () => {
    onClose(false);
    if (onOk) {
      onOk();
    }
  };
  const handleCancel = () => {
    onClose(false);
  };

  return (
    <Modal
      styles={modalstyles}
      title={title ? <p className="title">{title}</p> : null}
      open={isOpen}
      onCancel={handleCancel}
      centered
      closeIcon={title || showCloseIcon ? true : null}
      footer={[
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          {cancelText && (
            <Button
              key="cancel"
              onClick={handleCancel}
              style={{
                background: "#F5FAFF",
                width: "30%",
                color: "#67809A",
                marginRight: "15px",
              }}
            >
              {cancelText}
            </Button>
          )}
          <Button key="ok" onClick={handleOk} style={style ?? { width: "30%" }}>
            {onOkText ?? "OK"}
          </Button>
        </div>,
      ]}
    >
      {children}
    </Modal>
  );
};

export default ReusableModal;
